import { Middleware } from 'redux';

import {
  failCalling,
  finishCalling,
  noInternetCalling,
  startCalling
} from '../actions/network';
import {
  successCreateNote,
  successDestroyNote,
  successReadNotesByGroup,
  successReadNotesDiff,
  successUpdateNote
} from '../actions/note';
import DeleteNote from '../apis/DeleteNote';
import GetNotesDiff from '../apis/GetNotesDiff';
import GetNotesGroup from '../apis/GetNotesGroup';
import PostNote from '../apis/PostNote';
import PutNote from '../apis/PutNote';

const MIDDLEWARE = 'notes';

const notesMiddleware: Middleware = store => next => action => {
  switch (action.type) {
    case 'READ_NOTES_BY_GROUP':
      readNotesGroup(store, action);
      break;

    case 'READ_NOTES_DIFF':
      readNotesDiff(store, action);
      break;

    case 'CREATE_NOTE':
      createNote(store, action);
      break;
    case 'UPDATE_NOTE':
      updateNote(store, action);
      break;

    case 'DESTROY_NOTE':
      destroyNote(store, action);
      break;
  }
  next(action);
};

const readNotesGroup = (store: any, action: any) => {
  const METHOD = 'readNotesGroup';
  console.log(MIDDLEWARE + ':' + 'Call API: GetNotesGroup');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetNotesGroup();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.group, store.getState().Account).then(
        notes => {
          store.dispatch(successReadNotesByGroup(notes));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const readNotesDiff = (store: any, action: any) => {
  const METHOD = 'readNotesDiff';
  console.log(MIDDLEWARE + ':' + 'Call API: GetNotesDiff');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new GetNotesDiff();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(store.getState().Account).then(
        notes => {
          store.dispatch(successReadNotesDiff(notes));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const createNote = (store: any, action: any) => {
  const METHOD = 'createNote';
  console.log(MIDDLEWARE + ':' + 'Call API: PostNote');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PostNote();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.note, store.getState().Account).then(
        note => {
          store.dispatch(successCreateNote(note));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const updateNote = (store: any, action: any) => {
  const METHOD = 'updateNote';
  console.log(MIDDLEWARE + ':' + 'Call API: PutNote');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new PutNote();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.note, store.getState().Account).then(
        note => {
          store.dispatch(successUpdateNote(note));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

const destroyNote = (store: any, action: any) => {
  const METHOD = 'destroyNote';
  console.log(MIDDLEWARE + ':' + 'Call API: DeleteNote');
  if (store.getState().Network.isInternetAvailable) {
    if (!store.getState().Network.calling.includes(MIDDLEWARE + METHOD)) {
      const api = new DeleteNote();
      store.dispatch(startCalling(MIDDLEWARE + METHOD));
      api.execute(action.note, store.getState().Account).then(
        note => {
          store.dispatch(successDestroyNote(action.note));
          store.dispatch(finishCalling(MIDDLEWARE + METHOD));
        },
        errorMessage => {
          store.dispatch(failCalling(MIDDLEWARE + METHOD, errorMessage));
        }
      );
    }
  } else {
    store.dispatch(noInternetCalling());
  }
};

export default notesMiddleware;



// WEBPACK FOOTER //
// ./src/middlewares/notes.ts